import { render, staticRenderFns } from "./ReportEdit.vue?vue&type=template&id=efafa54c&"
import script from "./ReportEdit.vue?vue&type=script&lang=js&"
export * from "./ReportEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports